<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">New Category</span>
      <span v-else>Edit Category</span>
    </h1>
    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col class="py-2" sm="6" cols="12">
            <form-group name="category" :attribute="`fields.category`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.category"
                  type="text"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col sm="6" cols="12" class="py-2">
            <section class="increment-label">
              <span>Order</span>
              <number-input
                center
                v-model="form.order"
                :min="1"
                :step="1"
                controls
              ></number-input>
            </section>
          </v-col>
          <v-col cols="12">
            <form-group name="description" :attribute="`fields.description`">
              <template slot-scope="{ attrs, listeners }">
                <v-textarea
                  label="Description"
                  regular
                  v-bind="attrs"
                  v-on="listeners"
                  v-model.trim="form.description"
                ></v-textarea>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12">
            <v-btn
              class="success text-capitalize mt-8"
              large
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import { StoreData, ShowData, UpdateData } from "@/helpers/apiMethods";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: {
        category: "",
        order: "",
        description: "",
      },
      isEdited: false,
      loadingData: false,
      globalServerErrors: null,
    };
  },

  created() {
    this.editCreateBoolean();
  },
  methods: {
    handleSave() {
      if (!this.isEdited) {
        this.createDiscountCategories();
      } else {
        this.editDiscountCategories();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `content/discount-categories`,
        id: id,
      })
        .then((res) => {
          const { discount_category } = res.data;
          this.form = discount_category;
        })
        .catch(() => {});
    },
    createDiscountCategories() {
      const formData = new FormData();
      Object.keys(this.form).forEach((formItem) => {
        formData.append(formItem, this.form[formItem]);
      });
      StoreData({
        reqName: `content/discount-categories`,
        data: formData,
      })
        .then(() => {
          history.go(-1);
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editDiscountCategories() {
      const formData = new FormData();
      if (!this.photoChange) {
        delete this.form.photo;
      }
      Object.keys(this.form).forEach((formItem) => {
        if (
          formItem === "photo_url" ||
          formItem === "sub_types" ||
          formItem === "is_family"
        ) {
          return;
        } else {
          if (this.form[formItem] != null) {
            formData.append(formItem, this.form[formItem]);
          }
        }
      });
      formData.append("_method", "put");
      UpdateData({
        reqName: `content/discount-categories`,
        data: formData,
        id: this.$route.params.id,
      })
        .then(() => {
          this.isEdited = false;
          history.go(-1);

          this.reset();
        })
        .catch((err) => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "discountsCategoryEdit") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
      },
      immediate: true,
      deep: true,
    },
  },
  validations: {
    form: {
      category: {
        required,
        maxLength: maxLength(255),
      },
      description: {
        minLength: minLength(3),
      },
    },
  },
};
</script>
